import script from "./Verify.vue?vue&type=script&setup=true&lang=ts"
export * from "./Verify.vue?vue&type=script&setup=true&lang=ts"

import "./Verify.vue?vue&type=style&index=0&id=13551614&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13551614"]])

export default __exports__